
<div class="relative">
  <input
    :id="id"
    class="radio-button"
    :value="radioValue"
    type="radio"
    :name="radioName"
    :disabled="disabled"
    :required="required"
    :checked="checked"
    :tabindex="tabIndex"
    :aria-describedby="ariaDescribedByName"
    @change="radioSelection($event.target.value)"
    @blur="$emit('blur')"
  />
  <label :for="id" class="radio-button-label">{{ labelName }}</label>
</div>
